import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '730px',
    minWidth: '299px',
    width: '100%',
    alignSelf: 'center',
    marginBottom: '90px',
  },
  pageTitle: {
    [theme.breakpoints.down('sm')]: {
      marginTop: '15px',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '23px',
    },
    fontSize: '33px',
    fontWeight: '400',
    color: '#fff',
    marginBottom: '35px',
  },
  ttiTextArea: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.8rem',
    },
    width: '100%',
    fontSize: '0.9rem',
    backgroundColor: 'black',
    color: 'white',
    padding: '12px',
    borderRadius: '8px',
    outline: 'none',
    resize: 'none',
    overflowY: 'auto',
    '&:active': {
      outline: 'none',
    },
    '&:focus': {
      outline: 'none',
    },
    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#292929',
      borderRadius: '10px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#404040',
      borderRadius: '10px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#9A9A9A',
    },
    '&::-webkit-scrollbar-thumb:active': {
      background: '#9A9A9A',
    },
  },
  characters: {
    [theme.breakpoints.down('xs')]: {
      height: '1.2rem',
      fontSize: '0.6rem',
    },
    height: '1.3rem',
    fontSize: '0.8rem',
    color: '#fff',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
  },
  imageContainer: {
    [theme.breakpoints.down('xs')]: {
      height: '20rem',
    },
    width: '100%',
    height: '26rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#000000',
    position: 'relative',
    marginBottom: '16px',
    borderRadius: '8px',
  },
  loadingContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  circularProgress: {
    width: '1.4rem !important',
    height: '1.4rem !important',
    color: 'white !important',
    marginBottom: '1rem',
  },
  loadingText: {
    color: '#fff',
    fontWeight: '300',
    textAlign: 'center',
    marginBottom: '0.5rem',
  },
  image: {
    maxWidth: '100%',
    maxHeight: '100%',
    display: 'block',
    borderRadius: '8px',
  },
  smallImage: {
    [theme.breakpoints.down('xs')]: {
      maxHeight: '4rem',
      maxWidth: '4rem',
    },
    maxHeight: '6rem',
    maxWidth: '6rem',
    width: 'auto',
    height: 'auto',
    objectFit: 'contain',
    border: '0.2rem solid #fff',
    borderRadius: '0.5rem',
    cursor: 'pointer',
    '&:hover': {
      borderColor: '#CAFF73',
    },
  },
  downloadButton: {
    [theme.breakpoints.down('xs')]: {
      width: '1.5rem',
      height: '1.5rem',
    },
    position: 'absolute',
    top: '0.5rem',
    right: '0.5rem',
    color: 'black',
    border: 'none',
    borderRadius: '0.5rem',
    width: '2.5rem',
    height: '2.5rem',
    cursor: 'pointer',
    backgroundColor: '#CAFF73',
    padding: '5px 0 0 0 !important',
  },
  downloadIcon: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.2rem !important',
    },
    fontSize: '1.5rem',
  },
  overlay: {
    [theme.breakpoints.down('xs')]: {
      gap: '0.3rem',
    },
    gap: '0.5rem',
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    bottom: '1%',
    backgroundColor: 'rgba(255, 255, 255, 0.1)' /* Semi-transparent background */,
    backdropFilter: 'blur(10px)' /* Blur effect for the background */,
    padding: '0.3rem' /* Add some padding for spacing */,
    borderRadius: '0.5rem' /* Smooth rounded corners */,
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.3)' /* Optional shadow for better contrast */,
  },
  lastLineContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  settingButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  settingButton: {
    [theme.breakpoints.down('xs')]: {
      height: '2.5rem',
      fontSize: '0.8rem',
      width: '5.5rem',
    },
    height: '2.8rem',
    width: '7rem',
    backgroundColor: '#141414',
    padding: '0.5rem',
    fontSize: '0.8rem',
    borderRadius: '8px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    border: '1px solid #fafafa',
  },
  settingTypo: {
    [theme.breakpoints.down(600)]: {
      fontSize: '0.7rem !important',
      marginLeft: '0.2rem',
    },
    marginLeft: '0.3rem',
    fontSize: '0.8rem !important',
    color: '#fff',
  },
  tuneIcon: {
    '& svg': {
      fontSize: '20rem',
    },
    [theme.breakpoints.down(600)]: {
      fontSize: '1.3rem',
    },
    color: '#fff',
  },
  submitContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  },
  infoContainer: {
    display: 'flex',
    alignItems: 'start',
  },
  coinContainer: { marginLeft: '4px' },
  coin: {
    [theme.breakpoints.down('xs')]: {
      height: '1rem',
      fontSize: '0.65rem',
    },
    height: '1.5rem',
    fontSize: '0.8rem',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  stepHeader: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '16px',
    },
    fontSize: '16px',
    marginBottom: '20px',
    color: '#fff',
    fontWeight: '400',
    display: 'flex',
    alignItems: 'center',
  },
  section: {
    marginBottom: '20px',
  },
  modelCardContainer: {
    [theme.breakpoints.down('xs')]: {
      gap: '0.6rem',
    },
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    gap: '1rem',
  },
  stepHeaderChecked: {
    width: '19px',
    height: '18px',
    marginRight: '9px',
  },
  stepHeaderNum: {
    marginRight: '9px',
    fontSize: '13px',
    borderRadius: '50%',
    border: '2px solid #fff',
    width: '20px',
    height: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: '2px',
  },
  emptyModelCard: {
    [theme.breakpoints.down('xs')]: {
      width: `9rem`,
      height: '9rem',
      fontSize: '12px',
      padding: '36px',
      gap: '6px',
      lineHeight: '1.2',
    },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
    width: `10rem`,
    height: '10rem',
    borderRadius: '8px',
    padding: '12px',
    color: '#9A9A9A',
    fontSize: '16px',
    textAlign: 'center',
    fontWeight: '300',
    backgroundColor: '#1C1C1C',
    cursor: 'pointer',
  },
  modelPlusIcon: {
    fontSize: '32px !important',
    color: '#9A9A9A',
  },
  modelCard: {
    [theme.breakpoints.down('xs')]: {
      width: `9rem`,
      height: '9rem',
      fontSize: '1rem',
    },
    flex: '0 0 auto',
    width: `10rem`,
    height: '10rem',
    backgroundColor: '#161616',
    borderRadius: '8px',
    color: '#fff',
    fontSize: '1.5rem',
    fontWeight: '400',
    position: 'relative',
    display: 'flex',
  },
  modelDeleteButton: {
    position: 'absolute',
    top: '8px',
    right: '8px',
    cursor: 'pointer',
  },
  modelDeleteIcon: {
    color: '#fff',
    width: '20px',
    filter: 'drop-shadow(0 0 4px rgba(0,0,0,0.6))',
  },
  modelCoverImg: {
    [theme.breakpoints.down('xs')]: {
      width: `9rem`,
      height: '9rem',
    },
    position: 'absolute',
    zIndex: '0',
    borderRadius: '0.4rem',
    width: `10rem`,
    height: '10rem',
    objectFit: 'cover',
  },
  modelUsageTag: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '10px',
    },
    position: 'absolute',
    zIndex: '3',
    borderRadius: '1rem',
    padding: '3px 5px',
    fontSize: '11px',
    fontWeight: '400',
    color: '#000',
    backgroundColor: '#fff',
    top: '8px',
    left: '8px',
    border: '1px solid #e2e2e2',
  },
  modelCardContent: {
    [theme.breakpoints.down('xs')]: {
      padding: '4px 10px 0 10px',
      gap: '3px',
    },
    position: 'absolute',
    width: '100%',
    zIndex: '2',
    display: 'flex',
    flexDirection: 'column',
    alightItems: 'center',
    gap: '5px',
    borderRadius: '0 0 8px 8px',
    bottom: '0',
    backgroundColor: 'rgb(0, 0, 0, 0.6)',
    padding: '0.4rem 0.6rem 0.3rem 0.6rem',
  },
  modelCardStrengthContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  modelCardStrengthTitle: {
    fontSize: '10px',
    fontWeight: '300',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '-4px',
    width: '100%',
  },
  modelCardStrengthSliderRoot: {
    color: '#fff',
    padding: '13px 0 !important',
    '& .MuiSlider-thumb': {
      [theme.breakpoints.down('xs')]: {
        width: '0.6rem',
        height: '1rem',
      },
      width: '0.7rem',
      height: '1.2rem',
      borderRadius: '2rem',
      backgroundColor: '#fff',
      boxShadow: '0 0 0.5rem 0 rgba(0, 0, 0, 0.40)',
      '&:focus, &:hover, &.Mui-active': {
        boxShadow: 'inherit',
      },
    },
    '& .MuiSlider-track': {
      border: '1px solid white',
      backgroundColor: '#fff',
    },
    '& .MuiSlider-rail': {
      backgroundColor: '#fff',
    },
  },

  modelCardLabel: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '14px',
    },
    flex: 1,
    fontSize: '1rem',
    lineHeight: '1.5rem',
    overflowWrap: 'anywhere',
    display: '-webkit-box',
    WebkitLineClamp: 1,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  tooltipImg: {
    [theme.breakpoints.down('xs')]: {
      width: '14px',
      marginTop: '0',
    },
    width: '16px',
    marginTop: '3px',
  },
  submitButton: {
    [theme.breakpoints.down('xs')]: {
      padding: '0.8rem',
      fontSize: '0.8rem',
      width: '5.5rem',
      height: '2.5rem',
    },
    width: '7rem',
    height: '2.8rem',
    backgroundColor: '#CAFF73',
    padding: '0.7rem',
    fontSize: '0.9rem',
    borderRadius: '8px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  submitButtonInProgress: {
    [theme.breakpoints.down('xs')]: {
      padding: '0.8rem',
      fontSize: '0.8rem',
      width: '5.5rem',
      height: '2.5rem',
    },
    width: '7rem',
    height: '2.8rem',
    backgroundColor: '#767676',
    padding: '0.7rem',
    fontSize: '0.9rem',
    borderRadius: '8px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  submitTypo: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.7rem',
    },
    fontSize: '0.8rem',
  },
  indentation: { marginLeft: '16px' },
  threshold: {
    [theme.breakpoints.down('xs')]: {
      height: '2.5rem',
      fontSize: '0.8rem',
    },
    marginLeft: '0.3rem',
    height: '2.8rem',
    width: '4rem',
    color: 'white',
    backgroundColor: '#141414',
    padding: '0.5rem',
    fontSize: '0.8rem',
    borderRadius: '8px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    border: '1px solid #fafafa',
  },
}));

export { useStyles };
